import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  days: 1,
  from: {},
  to: {},
  motorField: "",
  imei: "",
  startTime: null,
  endTime: null,
  frequency: "Day",
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    reset: () => initialState,
    setDays: (state, action) => {
      return {
        ...state,
        days: action.payload,
      };
    },
    setFrom: (state, action) => {
      return {
        ...state,
        from: action.payload,
      };
    },
    setTo: (state, action) => {
      return {
        ...state,
        to: action.payload,
      };
    },
    setMotorField: (state, action) => {
      return {
        ...state,
        motorField: action.payload,
      };
    },
    setImei: (state, action) => {
      return {
        ...state,
        imei: action.payload,
      };
    },
    setStartTime: (state, action) => {
      return {
        ...state,
        startTime: action.payload,
      };
    },
    setEndTime: (state, action) => {
      return {
        ...state,
        endTime: action.payload,
      };
    },
    setFrequency: (state, action) => {
      return {
        ...state,
        frequency: action.payload,
      };
    },
  },
});

export const {
  setDays,
  reset,
  setFrom,
  setTo,
  setMotorField,
  setImei,
  setStartTime,
  setEndTime,
  setFrequency,
} = filterSlice.actions;

export default filterSlice.reducer;
